export default "__VITE_ASSET__Ppea7CrH__"